import type { QuestionSection } from '@/domain/types';

/**
 * Display names for the three compatibility tiers.
 *
 * Presentation only, and kept out of `domain/types.ts` for the same reason the
 * theme emoji are kept out of the questions file: the model should not have an
 * opinion about wording. Short, because these are rendered as a small tag
 * beside a theme name and nothing here should compete with it.
 */
export const SECTION_LABELS: Record<QuestionSection, string> = {
  core: 'Core',
  lifestyle: 'Lifestyle',
  preference: 'Preference',
};

export function sectionLabel(section: QuestionSection): string {
  return SECTION_LABELS[section];
}
